import { NotificationService } from './../../../../../core/src/lib/notifications/notifications.service';
import { Component, OnInit } from '@angular/core';

import { Store, select } from '@ngrx/store';
import { IssuedCategoryDto } from '@cradua/data';
import { Observable } from 'rxjs/internal/Observable';
import { routeAnimations, ROUTE_ANIMATIONS_ELEMENTS } from 'libs/core/src/lib/animations';
import { GatewayFacade } from 'libs/gateway/src/lib/states/+gateway/gateway.facades';

@Component({
  selector: 'cradua-issuedcategory-container',
  templateUrl: './issuedcategory-container.component.html',
  styleUrls: ['./issuedcategory-container.component.scss']
})
export class IssuedCategoryContainerComponent implements OnInit {

  routeAnimationsElements = ROUTE_ANIMATIONS_ELEMENTS;
  issuedcategorys$: Observable<IssuedCategoryDto[]>;
  loading: boolean;
  isLoading$: Observable<boolean>;
  constructor(
    private gatwayFacade: GatewayFacade,
    private notificationService: NotificationService
  ) {}

  ngOnInit() {
    this.isLoading$ = this.gatwayFacade.isLoadingGateway("IssuedCategory");
    this.issuedcategorys$ = this.gatwayFacade.loadGateway("IssuedCategory");
    this.issuedcategorys$.subscribe(data => {
      console.log("data: cont.",data);

    })
  }

/**
 this method dispatches array of ids to the effects,
 which handle the sending of data asynchronously
  */

  onDeleteIssuedCategory(deletedValue: any) {
    this.gatwayFacade.remove("IssuedCategory", deletedValue);
    // this.store.dispatch(IssuedCategoryStoreActions.removeIssuedCategory({ids: deletedValue}));
    this.notificationService.success('Deleted Successfully');
  }


// this method control both the create and update

  onSubmitIssuedCategory(formValue: any) {
    console.log("form value: ", formValue);
    formValue.IssuedCategorys = formValue.IssuedCategorys.reverse();
    event.preventDefault();
    const pullData = formValue.IssuedCategorys;
    //const newPullData = formValue.IssuedCategoryes;

// declare two empty array to hold update and create data
  let allUpdates = [] ;
  let addAllIssuedCategory = [];


// loop through the form data to check for update and create

  for(let i = 0; i < pullData.length; i++) {
    if(pullData[i].id !== null) {
      allUpdates.push(pullData[i]);
    } else {
      delete pullData[i].id;
      addAllIssuedCategory.push(pullData[i]);
    }
  }

// check if the addAllIssuedCategory array is not empty, then dispatch the data to the store
   if(addAllIssuedCategory.length !== 0) {
    this.gatwayFacade.add('IssuedCategory', addAllIssuedCategory);
    // this.store.dispatch(IssuedCategoryStoreActions.addIssuedCategory({newIssuedCategory: addAllIssuedCategory}));

   }

// dispatch update data to the store
this.gatwayFacade.update('IssuedCategory', allUpdates, ['id']);
    // this.store.dispatch(IssuedCategoryStoreActions.updateIssuedCategory({updateIssuedCategory: allUpdates}));
    this.notificationService.success('Saved Successfully');

  }

}



